import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    //console.log('Recibido en interpret:', data)
    const consult = `Quiero que interpretes una **Tirada de Atracción Magnética** con 10 cartas. Esta tirada revela qué tipo de energía está emitiendo el consultante ${
        data.consultante
    } y cómo mejorar su vibración para atraer mejores oportunidades en el amor, el trabajo o la vida en general ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' + data.consulta + ','
            : ''
    } según estas cartas: **Energía actual del consultante:** ${formatCardLabel(cards[0])}, **¿Qué tipo de personas o situaciones está atrayendo?:** ${formatCardLabel(cards[1])}, **¿Por qué está atrayendo esto?:** ${formatCardLabel(cards[2])}, **¿Cómo está afectando su vida esta energía?:** ${formatCardLabel(cards[3])}, **¿Qué puede hacer para mejorar su vibración y atraer lo que realmente desea?:** ${formatCardLabel(cards[4])}, **Energía que necesita reforzar para manifestar cosas positivas:** ${formatCardLabel(cards[5])}, **Energía que debe eliminar o dejar atrás para evitar atraer lo negativo:** ${formatCardLabel(cards[6])} **Cómo potenciar su magnetismo personal:**: ${formatCardLabel(cards[7])} **Consejo del tarot para ajustar su energía de atracción:** ${formatCardLabel(cards[8])} y **Resultado si trabaja en su vibración:** ${formatCardLabel(cards[9])}. Explica detalladamente cada carta y su significado en la posición donde ha salido y detecta patrones o bloqueos energéticos. Da consejos prácticos para mejorar la vibración del consultante y atraer lo que realmente desea. Si notas bloqueos emocionales o energéticos, sugiere ejercicios o cambios en su mentalidad. Usa un tono motivador, claro y empático. Dirígete directamente al consultante, no utilices la tercera persona refiriendote a la consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 parrafos despues de la interpretación, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
